import Swiper, { Autoplay, Navigation } from "swiper";
import { pauseAnimation, resumeAnimation, isAnimationStopped } from "../../../../assets/scripts/extends/cookiesManager";

const timelineCarousel = document.querySelectorAll(".timeline-carousel .swiper");

timelineCarousel.forEach((slider) => {
  const prevArrow = slider.querySelector(".prev");
  const nextArrow = slider.querySelector(".next");

  const timelineCarouselOptions = {
    modules: [Autoplay, Navigation],
    spaceBetween: 20,
    slidesPerView: "auto",
    loop: true,
    loopedSlides: 4,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
    freeMode: true,
    speed: 5000,
    grabCursor: true,
    centeredSlides: true,
  };

  if (!isAnimationStopped()) {
    timelineCarouselOptions.autoplay = {
      delay: 1,
      disableOnInteraction: true,
    };
  }

  const timelineCarouselSwiper = new Swiper(slider, timelineCarouselOptions);

  const wrapper = slider.querySelector(".swiper-wrapper");

  let isFirstTime = true;
  const stopAndChangeSpeed = () => {
    if (isFirstTime) {
      const computedStyles = window.getComputedStyle(wrapper);
      const currentTransform = computedStyles.transform;
      wrapper.style.transform = "";
      wrapper.style.transform = currentTransform;
      timelineCarouselSwiper.params.speed = 300;
      timelineCarouselSwiper.autoplay.stop();
      wrapper.style.transitionDuration = "300ms";
      isFirstTime = false;
    }
  };

  timelineCarouselSwiper.on("touchMove", function () {
    stopAndChangeSpeed();
  });

  nextArrow.addEventListener("click", function () {
    stopAndChangeSpeed();
  });
  prevArrow.addEventListener("click", function () {
    stopAndChangeSpeed();
  });
});
